import { AlertCreatedButton, ResolutionStatusPill } from "./styles";
import { getAlertRequestResolutionLabel } from "../../../utils/alertRequestResolution";

/**
 * Insignia padronizada de resolução.
 * Se `created` e `onOpenAlert` → botão "Alerta Criado" que abre o alerta.
 */
export default function AlertRequestResolutionBadge({
  resolution,
  onOpenAlert,
  opening = false,
  title = "Abrir alerta criado",
}) {
  const label = getAlertRequestResolutionLabel(resolution);
  const status = resolution || "pending";

  if (resolution === "created" && typeof onOpenAlert === "function") {
    return (
      <AlertCreatedButton
        type="button"
        title={title}
        disabled={opening}
        onClick={(e) => {
          e.stopPropagation();
          onOpenAlert(e);
        }}
      >
        {opening ? "Abrindo…" : "Alerta Criado"}
      </AlertCreatedButton>
    );
  }

  return <ResolutionStatusPill $status={status}>{label}</ResolutionStatusPill>;
}
